import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { 
  FileText, 
  Save,
  Eye
} from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/axios';

const AdminLegalPage = () => {
  const [pages, setPages] = useState({
    mentions: '# Mentions légales\n\n## Éditeur du site\n...',
    privacy: '# Politique de confidentialité\n\n## Données collectées\n...',
    cgv: '# Conditions Générales de Vente\n\n## Article 1\n...',
    cookies: '# Politique des cookies\n\n## Utilisation des cookies\n...'
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/settings/legal', pages);
      toast.success('Pages légales sauvegardées');
    } catch (error) {
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-[#1a365d]">Pages légales</h1>
          <p className="text-[#64748b]">Gérez vos mentions légales, CGV et politique de confidentialité</p>
        </div>
        <Button onClick={handleSave} disabled={saving} className="bg-amber-600 hover:bg-amber-700">
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Sauvegarde...' : 'Sauvegarder'}
        </Button>
      </div>

      <Tabs defaultValue="mentions" className="space-y-4">
        <TabsList>
          <TabsTrigger value="mentions">Mentions légales</TabsTrigger>
          <TabsTrigger value="privacy">Confidentialité</TabsTrigger>
          <TabsTrigger value="cgv">CGV</TabsTrigger>
          <TabsTrigger value="cookies">Cookies</TabsTrigger>
        </TabsList>

        <TabsContent value="mentions">
          <Card>
            <CardHeader>
              <CardTitle>Mentions légales</CardTitle>
              <CardDescription>Informations obligatoires sur l'éditeur du site</CardDescription>
            </CardHeader>
            <CardContent>
              <Textarea 
                value={pages.mentions}
                onChange={(e) => setPages({...pages, mentions: e.target.value})}
                className="min-h-[400px] font-mono"
                placeholder="Contenu en Markdown..."
              />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="privacy">
          <Card>
            <CardHeader>
              <CardTitle>Politique de confidentialité</CardTitle>
              <CardDescription>RGPD et protection des données</CardDescription>
            </CardHeader>
            <CardContent>
              <Textarea 
                value={pages.privacy}
                onChange={(e) => setPages({...pages, privacy: e.target.value})}
                className="min-h-[400px] font-mono"
                placeholder="Contenu en Markdown..."
              />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="cgv">
          <Card>
            <CardHeader>
              <CardTitle>Conditions Générales de Vente</CardTitle>
              <CardDescription>Conditions contractuelles</CardDescription>
            </CardHeader>
            <CardContent>
              <Textarea 
                value={pages.cgv}
                onChange={(e) => setPages({...pages, cgv: e.target.value})}
                className="min-h-[400px] font-mono"
                placeholder="Contenu en Markdown..."
              />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="cookies">
          <Card>
            <CardHeader>
              <CardTitle>Politique des cookies</CardTitle>
              <CardDescription>Utilisation des cookies et traceurs</CardDescription>
            </CardHeader>
            <CardContent>
              <Textarea 
                value={pages.cookies}
                onChange={(e) => setPages({...pages, cookies: e.target.value})}
                className="min-h-[400px] font-mono"
                placeholder="Contenu en Markdown..."
              />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminLegalPage;
